export const OPTIMISTIC_ADD_ITEM_TO_CART_LOADING_TIME_MS = 1000;
